import { Card, Typography, Skeleton } from 'antd';
import { useGetTranscriptionList } from 'src/hooks/transcription';
import { EncounterPhase } from 'src/models';
import { TranscriptionMessage } from 'src/models';

const { Text } = Typography;

interface TranscriptionCardProps {
  encounterId: string;
  phase: EncounterPhase | null;
}

export const TranscriptionCard: React.FC<TranscriptionCardProps> = ({
  encounterId,
  phase,
}) => {
  const { data: transcriptionData, isLoading } = useGetTranscriptionList({
    encounterId,
    encounterPhase: phase,
    type: 'live',
  });

  const transcriptionJson =
    transcriptionData?.transcriptions[0]?.transcription_json;
  const hasTranscriptionData =
    Array.isArray(transcriptionJson) && transcriptionJson.length > 0;

  return (
    <Card title="Call Transcript">
      <div className="py-8">
        {isLoading ? (
          <div className="flex flex-col gap-4">
            {[...Array(5)].map((_, idx) => (
              <div key={idx} className="flex gap-2 items-start">
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: 60, height: 20 }}
                />
                <Skeleton
                  paragraph={{ rows: 1, width: '80%' }}
                  title={false}
                  active
                />
              </div>
            ))}
          </div>
        ) : hasTranscriptionData ? (
          <div className="flex flex-col gap-2">
            {transcriptionJson.map(
              (item: TranscriptionMessage, idx: number) => (
                <div key={idx} className="flex gap-2 items-start">
                  <Text strong className="capitalize min-w-[60px]">
                    {item.role}:
                  </Text>
                  <Text>{item.content}</Text>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center">
            <Text type="secondary">N/A</Text>
          </div>
        )}
      </div>
    </Card>
  );
};
